/**
 * 全部图标为内联 SVG（描边取自样张，零外链、零图标库依赖）。
 */

export function BackIcon() {
  return (
    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="#414A57" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 4.5L7.5 12l7.5 7.5" />
    </svg>
  );
}

export function ChevronRight({ size = 10, stroke = '#193D87' }: { size?: number; stroke?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 10 10" fill="none" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3.5 1.5L7.3 5 3.5 8.5" />
    </svg>
  );
}

export function ArrowRight() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#193D87" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 4.5L16.5 12 9 19.5" />
    </svg>
  );
}

/* ── 底栏 tab 图标（2026-08-27 主公选定「丙 · Material 双态」）──────────────
   改前：房子由三段**互不相接**的线拼成（屋檐、墙体、门各一段），22px 下接头处有断口；
         人像是「圆 ＋ 一段圆弧」，肩弧两端齐平切断，像被剪掉一截。两个都是手画的。
   改后：换 Material Symbols Rounded 成品线稿，并且**选中态实心、未选态描边**——
         底栏最要紧的活是告诉用户"我在哪一页"，原先只靠变蓝一个信号，
         现在形状本身也在说话，扫一眼就分得清。
   许可证：Material Symbols 是 Apache 2.0，**不要求在页面上露出署名**，
         仓库里保留声明即可 —— 见 packages/citizen/NOTICE。
         （对比：Solar 等图标集是 CC BY 4.0，要署名，所以小助手那枚气泡是自绘的。）
   `on` 由 TabBar 按当前路由传入，与 `.tab.on` 的变色是同一个判断，不会打架。 */
export function HomeIcon({ on = false }: { on?: boolean }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
      {on ? (
        <path
          fill="currentColor"
          d="M4 19v-9q0-.475.213-.9t.587-.7l6-4.5q.525-.4 1.2-.4t1.2.4l6 4.5q.375.275.588.7T20 10v9q0 .825-.588 1.413T18 21h-3q-.425 0-.712-.288T14 20v-5q0-.425-.288-.712T13 14h-2q-.425 0-.712.288T10 15v5q0 .425-.288.713T9 21H6q-.825 0-1.412-.587T4 19"
        />
      ) : (
        <path
          fill="currentColor"
          d="M6 19h3v-5q0-.425.288-.712T10 13h4q.425 0 .713.288T15 14v5h3v-9l-6-4.5L6 10zm-2 0v-9q0-.475.213-.9t.587-.7l6-4.5q.525-.4 1.2-.4t1.2.4l6 4.5q.375.275.588.7T20 10v9q0 .825-.588 1.413T18 21h-4q-.425 0-.712-.288T13 20v-5h-2v5q0 .425-.288.713T10 21H6q-.825 0-1.412-.587T4 19"
        />
      )}
    </svg>
  );
}

export function MineIcon({ on = false }: { on?: boolean }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
      {on ? (
        <path
          fill="currentColor"
          d="M9.175 10.825Q8 9.65 8 8t1.175-2.825T12 4t2.825 1.175T16 8t-1.175 2.825T12 12t-2.825-1.175M4 18v-.8q0-.85.438-1.562T5.6 14.55q1.55-.775 3.15-1.162T12 13t3.25.388t3.15 1.162q.725.375 1.163 1.088T20 17.2v.8q0 .825-.587 1.413T18 20H6q-.825 0-1.412-.587T4 18"
        />
      ) : (
        <path
          fill="currentColor"
          d="M9.175 10.825Q8 9.65 8 8t1.175-2.825T12 4t2.825 1.175T16 8t-1.175 2.825T12 12t-2.825-1.175M4 18v-.8q0-.85.438-1.562T5.6 14.55q1.55-.775 3.15-1.162T12 13t3.25.388t3.15 1.162q.725.375 1.163 1.088T20 17.2v.8q0 .825-.587 1.413T18 20H6q-.825 0-1.412-.587T4 18m2 0h12v-.8q0-.275-.137-.5t-.363-.35q-1.35-.675-2.725-1.012T12 15t-2.775.338T6.5 16.35q-.225.125-.363.35T6 17.2zm7.413-8.587Q14 8.825 14 8t-.587-1.412T12 6t-1.412.588T10 8t.588 1.413T12 10t1.413-.587"
        />
      )}
    </svg>
  );
}

export function ChatIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 5.5h16v10.5H10l-4.5 3.5V16H4z" />
      <path d="M8.5 9.5h7M8.5 12.5h4.5" />
    </svg>
  );
}

/**
 * 悬浮球「在线咨询」专用图标：带问号的对话气泡。
 * 描边色与线宽由 `.fab svg` 统一给（stroke #F2F8FE、width 1.7、round），此处只给形，
 * 故三条 path 不写任何描边属性，跟着 FAB 走白描边蓝底。
 */
/**
 * 小助手悬浮球的图标：**实心圆气泡＋三点**（2026-08-26 主公定 B 方案）。
 *
 * 改前是三段细线稿（气泡轮廓＋问号），21px 下笔画糊成一团、气泡尾巴还甩歪了。
 * 改后走实心：外轮廓是**正圆带一枚左下尾巴**，与悬浮球的圆是同一套形状语言；
 * 三个点用 `fill-rule="evenodd"` 从实心里**挖出来**（负形），不靠细笔画立字，
 * 所以缩到 22px 依旧干净。
 *
 * ★ 这条 path 是自绘的，不引任何图标库 —— Solar 等成品集是 CC BY 4.0、要署名，
 *   本项目要挂协会官网，索性照形状重画一版，省掉署名义务。零外链原则同样成立。
 */
export function ConsultBubbleIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.4 19.2Q5.4 21.2 2.2 21.9Q3.4 18.8 4.1 15.4A9.2 9.2 0 1 1 6.96 18.85Z
           M8 10.35a1.15 1.15 0 1 0 0 2.3a1.15 1.15 0 1 0 0-2.3Z
           M12.5 10.35a1.15 1.15 0 1 0 0 2.3a1.15 1.15 0 1 0 0-2.3Z
           M17 10.35a1.15 1.15 0 1 0 0 2.3a1.15 1.15 0 1 0 0-2.3Z"
      />
    </svg>
  );
}

export function PersonIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#66717F" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4" />
      <path d="M4.5 20.5c1.6-4 4.4-6 7.5-6s5.9 2 7.5 6" />
    </svg>
  );
}

/* ---- S4 个人中心用图标（path 逐条照 s4.html） ---- */

export function AvatarIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EAF2FB" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8.6" r="3.9" />
      <path d="M4.8 20.2c0-3.8 3.2-6.1 7.2-6.1s7.2 2.3 7.2 6.1" />
    </svg>
  );
}

/* ★ 2026-08-26 P5：下面四枚「我的」页图标的描边由**写死的十六进制**改成 `currentColor`。
   病根（主公真机实测「我的投诉那一行还是红的」）：`DocIcon` 写死 `stroke="#8C2C22"`（暗红），
   全站改蓝时它没跟上，而且**永远不会跟上**——写死就等于退出主题。
   现在四枚统一吃父级 `color`，颜色由 `styles/profile.css` 的 `.li-ic` 一处给。
   这四枚**只在 `/my`（Profile.tsx）用到**（全仓 grep 确认），改动波及面仅此一屏。
   `BellIcon` 原有的深/浅蓝双色关系保留：主体走 currentColor，铃舌那笔降透明度当浅色，
   这样它仍是双色，但两个色都跟着主题走。 */

export function DocIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 3.5h9.2L19 7.4v13.1H6z" />
      <path d="M15 3.5v4h4" />
      <path d="M9.6 11.2h6M9.6 14.6h4" />
    </svg>
  );
}

export function BellIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3.6c-3.4 0-5.6 2.3-5.6 5.5v3.6l-1.7 3h14.6l-1.7-3V9.1c0-3.2-2.2-5.5-5.6-5.5Z" />
      <path d="M9.9 18.9c.3 1 1.1 1.7 2.1 1.7s1.8-.7 2.1-1.7" opacity="0.66" />
    </svg>
  );
}

export function TelIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5.5 4.5h3l1.6 4-2 1.3a11.5 11.5 0 0 0 5.6 5.6l1.3-2 4 1.6v3a1.5 1.5 0 0 1-1.6 1.5C10.6 19 5 13.4 4 5.9a1.5 1.5 0 0 1 1.5-1.4z" />
    </svg>
  );
}

export function PinIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 21.2c4-4.2 6-7.5 6-10a6 6 0 1 0-12 0c0 2.5 2 5.8 6 10z" />
      <circle cx="12" cy="11" r="2.3" />
    </svg>
  );
}

export function ListGo() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#7A87A1" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 4.5L16.5 12 9 19.5" />
    </svg>
  );
}

export function PhoneIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#66717F" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <rect x="6" y="2.5" width="12" height="19" rx="3" />
      <path d="M10.5 18.5h3" />
    </svg>
  );
}

export function PenIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.5 4.5l5 5L9 20H4v-5z" />
      <path d="M12.5 6.5l5 5" />
    </svg>
  );
}

export function MicIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="2.5" width="6" height="11.5" rx="3" />
      <path d="M5.5 11.5a6.5 6.5 0 0013 0M12 18v3.5" />
    </svg>
  );
}

export function InfoIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#193D87" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v6M12 7.6v.6" />
    </svg>
  );
}

export function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="10.6" cy="10.6" r="6.4" />
      <path d="M15.4 15.4l4.4 4.4" />
    </svg>
  );
}

export function CheckMark({ size = 44, stroke = '#FFFFFF', width = 4.5 }: { size?: number; stroke?: string; width?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 44 44" fill="none">
      <path d="M11 22.5 19 30.5 33.5 14.5" stroke={stroke} strokeWidth={width} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function TinyCheck() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
      <path d="M5 12.5 10 17.5 19 7" stroke="#FFFFFF" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function EmptyIcon() {
  return (
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" aria-hidden="true">
      <circle cx="18" cy="18" r="11" stroke="#B3C0DA" strokeWidth="1.8" />
      <path d="M26 26l8 8" stroke="#B3C0DA" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

/**
 * 「我的投诉」空态占位图。
 *
 * ★ 只用矩形／圆／直线这类**抽象几何**：手攒贝塞尔去画具象画面是死路，
 *   而这一屏也不需要具象 —— 三张错位堆叠的空白纸就够说明「这里还没有东西」。
 * ★ 内联 SVG，零外链（市民端硬约束）；颜色取 base.css 令牌的实际值。
 */
export function EmptyCasesArt() {
  return (
    <svg width="132" height="104" viewBox="0 0 132 104" fill="none" aria-hidden="true">
      {/* 落影：让整组图不飘在半空 */}
      <ellipse cx="66" cy="90" rx="42" ry="6" fill="#DCE6FB" />
      {/* 后两张纸错位堆叠 */}
      <rect
        x="32"
        y="18"
        width="68"
        height="58"
        rx="9"
        fill="#EFF3FB"
        stroke="#D3E1EE"
        strokeWidth="1.6"
        transform="rotate(-8 66 47)"
      />
      <rect
        x="32"
        y="18"
        width="68"
        height="58"
        rx="9"
        fill="#FFFFFF"
        stroke="#C6D8E8"
        strokeWidth="1.6"
        transform="rotate(5 66 47)"
      />
      {/* 最前那张：正的，上面三条空行 */}
      <rect x="34" y="22" width="64" height="56" rx="9" fill="#FFFFFF" stroke="#B3C0DA" strokeWidth="1.8" />
      <rect x="44" y="36" width="30" height="5" rx="2.5" fill="#DCE6FB" />
      <rect x="44" y="48" width="44" height="4" rx="2" fill="#E9F0F7" />
      <rect x="44" y="58" width="34" height="4" rx="2" fill="#E9F0F7" />
      {/* 右上角一枚「加一条」的圆钮：空态里唯一的彩色，指向下一步 */}
      <circle cx="97" cy="28" r="13" fill="#FFFFFF" stroke="#B3C0DA" strokeWidth="1.6" />
      <path d="M91.5 28h11M97 22.5v11" stroke="#2E6BE6" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

/**
 * 「还没有收到过东西」的空态图 —— 被投诉方门户的空列表用。
 *
 * ★ 为什么不复用 `EmptyCasesArt`（2026-08-27 立）：那张图右上角那枚圆钮是
 *   **「加一条」**，指向「我要投诉」。被投诉方在这一屏**什么都加不了**，
 *   收到几条投诉不由他决定。摆一个点了没有下一步的加号，是给了个假入口。
 * ★ 同一套几何语言（抽象矩形／圆／直线，内联 SVG，零外链），
 *   只把那枚加号换成一个**空收件托盘**：东西是「送进来」的，不是「加出来」的。
 */
export function EmptyInboxArt() {
  return (
    <svg width="132" height="104" viewBox="0 0 132 104" fill="none" aria-hidden="true">
      <ellipse cx="66" cy="92" rx="42" ry="6" fill="#DCE6FB" />
      {/* 上方两张错位的纸：飘着，还没落进托盘 */}
      <rect
        x="38"
        y="10"
        width="56"
        height="42"
        rx="8"
        fill="#EFF3FB"
        stroke="#D3E1EE"
        strokeWidth="1.6"
        transform="rotate(-7 66 31)"
      />
      <rect x="40" y="14" width="52" height="40" rx="8" fill="#FFFFFF" stroke="#B3C0DA" strokeWidth="1.8" />
      <rect x="50" y="26" width="26" height="4.5" rx="2.25" fill="#DCE6FB" />
      <rect x="50" y="37" width="32" height="4" rx="2" fill="#E9F0F7" />
      {/* 空托盘：一道折线围出敞口，里面是空的 */}
      <path
        d="M28 62v16a5 5 0 005 5h66a5 5 0 005-5V62"
        stroke="#B3C0DA"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="#FFFFFF"
      />
      <path d="M28 62h20l5 7h26l5-7h20" stroke="#2E6BE6" strokeWidth="2" strokeLinejoin="round" opacity="0.55" />
    </svg>
  );
}

/** 「按这个筛选条件没有」的空态图：同一套几何语言，但换成一张纸 ＋ 一道筛选漏斗轮廓。 */
export function EmptyFilterArt() {
  return (
    <svg width="112" height="96" viewBox="0 0 112 96" fill="none" aria-hidden="true">
      <ellipse cx="56" cy="84" rx="34" ry="5.5" fill="#DCE6FB" />
      <rect x="28" y="14" width="56" height="60" rx="9" fill="#FFFFFF" stroke="#B3C0DA" strokeWidth="1.8" />
      <rect x="38" y="26" width="26" height="4.5" rx="2.25" fill="#E9F0F7" />
      <rect x="38" y="60" width="30" height="4" rx="2" fill="#E9F0F7" />
      {/* 漏斗：三条渐窄的横杠 ＋ 一根出口 */}
      <path
        d="M38 38h36M43 45h26M49 52h14M56 52v9"
        stroke="#2E6BE6"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.55"
      />
    </svg>
  );
}

export function AppealIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#193D87" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 6.5h16v11H9.5L5 20.5V17.5H4z" />
      <path d="M12 9.5v3.2M12 15.2v.4" />
    </svg>
  );
}

export function UploadIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7A87A1" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 16.5V4.5" />
      <path d="M7.5 9L12 4.5 16.5 9" />
      <path d="M4 15.5v3a2 2 0 002 2h12a2 2 0 002-2v-3" />
    </svg>
  );
}

/** 补录表单里「不可修改」那一栏的小锁。抽象几何形，手画即可。 */
export function LockIcon() {
  return (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="10.5" width="16" height="10.5" rx="2.5" />
      <path d="M8 10.5V7.5a4 4 0 118 0v3" />
    </svg>
  );
}

export function FileIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#2E6BE6" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8z" />
      <path d="M14 3v5h5" />
    </svg>
  );
}

/** T5 后续环节三枚图标 */
export function StepAccept() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path d="M5 2.8h9.2L17 5.6V19.2H5V2.8Z" stroke="#193D87" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M13.8 2.8v3h3" stroke="#193D87" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M8 12.6l2.1 2.1 4-4.4" stroke="#2E6BE6" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function StepCheck() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <circle cx="9.6" cy="9.6" r="5.8" stroke="#193D87" strokeWidth="1.5" />
      <path d="M14 14l4.4 4.4" stroke="#193D87" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M7.2 9.6h4.8M9.6 7.2v4.8" stroke="#2E6BE6" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

export function StepDone() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path d="M11 3.2c-3.2 0-5.2 2.2-5.2 5.2v3.4l-1.6 2.8h13.6l-1.6-2.8V8.4c0-3-2-5.2-5.2-5.2Z" stroke="#193D87" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M9 17.6c.3 1 1 1.6 2 1.6s1.7-.6 2-1.6" stroke="#2E6BE6" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function StepArrow() {
  return (
    <svg className="step-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#B3C0DA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 4.5L16.5 12 9 19.5" />
    </svg>
  );
}
